import { CDN_IMAGES } from '../../constants';
import { AppThemeConfig } from '../../types/app.types';
import { Provider } from '../../types/provider';

export const getConfig: (gameName: string, gameUrlSlug: string) => AppThemeConfig = (gameName, gameUrlSlug) => {
  return {
    gameName,
    isPremiumSubscriptionAvailable: false,
    wallpaper: `${CDN_IMAGES}/backgrounds/desktop-onboarding-bg.png`,
    paymentWallpaper: null,
    paymentCongratulationWallpaper: null,
    testimonials: [],
    primaryProviders: [Provider.Twitch, Provider.Google],
    fallbackRedirectUri: `https://mobalytics.gg/${gameUrlSlug}`,
  };
};
